var n=function(n,r,t){if(!n)return t;var e=r.find((function(r){return r.breakpoint===n}));return(null==e?void 0:e.settings).slidesToScroll||t};export{n as default};
